














import Vue from 'vue'

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: '道の駅を探す',
    },
    subtitle: {
      type: String,
      default: 'FIND A ROADSIDE STATION',
    },
    bg: {
      type: String,
      default: '../assets/roadside_stations/header.jpg',
    },
  },
})
